import { z } from 'zod';

import { israeliTaxIdSchema } from 'features/onboarding/schemas/primitives';

export const taxLegalSchema = z.object({
  taxId: israeliTaxIdSchema,
  officialBusinessName: z.string().min(1, 'required'),
});

export type TaxLegalInput = z.infer<typeof taxLegalSchema>;
